<template>
<div class="gallery">
  <div class="gallery-image" v-if="currentImage && currentImage.type === 'image'" :style="{ backgroundImage: `url(${currentImage.url})`}"></div>
  <iframe class="gallery-image" v-else-if="currentImage && currentImage.type === 'video'" :src="currentImage.url"></iframe>
  <div class="image-empty" v-else>
    No existen imagenes o videos para este proyecto
  </div>
  <div class="gallery-thumbnails">
    <div class="gallery-thumbnail" v-for="(image, index) in images" :key="index" @click="currentVal = index">
      <img v-if="image.type === 'image'" :src="image.url">
      <img v-if="image.type === 'video'" src="/video.png">
    </div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      currentVal: 0,
    };
  },
  props: {
    images: Array,
  },
  computed: {
    currentImage() {
      if (this.images && this.images.length > 0) {
        return this.images[this.currentVal];
      }
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
.gallery {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.image-empty {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gallery-image {
  background-color: #f6f6f6;
  // background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 400px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.gallery-thumbnails {
  width: 100%;
  max-width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  height: 90px;
  max-height: 90px;
  margin-top: 16px;
  display: flex;
}
.gallery-thumbnail {
  height: 100%;
  width: fit-content;
  cursor: pointer;
  margin-right: 12px;

  img {
    border-radius: 8px;
    height: 100%;
    width: auto;
  }
}
@media only screen and (max-width: 800px) {
  .gallery-image {
    height: 400px;
  }
}
@media only screen and (max-width: 500px) {
  .gallery-image {
    height: 200px;
  }
}
</style>

